module.exports = __webpack_public_path__ + "img/ico_point_active.bc220b02.svg";